<template>
  <div class="comp-quick-aside">
    <div @click="$emit('showFeedback')"
         class="flex-row-center"
         title="意见反馈">
      <span class="iconfont iconfankui"></span>
    </div>
    <div class="flex-row-center"
         @click="$router.push({name: 'HelpContact'})"
         title="联系我们">
      <span class="iconfont iconkefu"></span>
    </div>
    <!--<div class="flex-row-center" title="扫我下载"><span class="iconfont iconerweima"></span></div>-->
    <div class="flex-row-center"
         title="返回顶部"
         @click="gotoTop">
      <span class="iconfont iconzhiding"></span>
    </div>
  </div>
</template>

<script>
/*!*
 * @author yueheqin
 * @date 2019/7/10
 * @project zujuanzaixian
 * @desc
 */
export default {
  name: 'comp-quick-aside',
  props: {},
  data () {
    return {}
  },
  methods: {
    gotoTop () {
      $('html').animate({ scrollTop: 0 }, 500)
    }
  }
}
</script>

<style lang="less">
@import "../styles/_mixins-wln";

.comp-quick-aside {
  position: fixed;
  bottom: 100px;
  right: 0;
  z-index: 1000;

  & > div {
    background: @primary;
    color: #ffffff;
    padding: 15px;
    margin-top: 5px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}
</style>
